module.exports = __webpack_public_path__ + "img/vipevent_repurchase_icon@2x.0869c20b.png";